import React from "react";
import { motion } from "framer-motion";
import { FiAward, FiBriefcase, FiTrendingUp } from "react-icons/fi";
import "./ChairmanSection.css";
import useSiteSettings from '../../hooks/useSiteSettings';
import { resolveMedia } from '../../utils/media';

export default function ChairmanSection() {
  const { settings } = useSiteSettings();
  return (
    <section className="chs">
      <div className="container">
        <motion.div className="chs__wrap" initial={{ opacity: 0, y: 18 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.25 }} transition={{ duration: 0.5, ease: "easeOut" }}>
          <div className="chs__left"><div className="chs__imgWrap"><img src={resolveMedia(settings.ceoImage)} alt={settings.ceoName || 'Leadership'} /></div></div>
          <div className="chs__right">
            <div className="chs__kicker">{settings.ceoSectionKicker || 'Leadership'}</div>
            <h2 className="chs__name">{settings.ceoName || 'Chairman'}</h2>
            <div className="chs__role">{settings.ceoRole || 'Leadership'}</div>
            <p className="chs__text">{settings.ceoBioOne}</p>
            <p className="chs__text">{settings.ceoBioTwo}</p>
            <div className="chs__highlights">
              <div className="chs__hl"><FiBriefcase /><span>Industry Leadership</span></div>
              <div className="chs__hl"><FiAward /><span>Professional Credibility</span></div>
              <div className="chs__hl"><FiTrendingUp /><span>Growth Vision</span></div>
            </div>
            <div className="chs__quote">“{settings.ceoQuote}”</div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
